import React from 'react';
import { Modal } from 'antd';

const CustomModal = ({
    open,
    onCancel,
    onOk,
    title,
    children,
    width = 700,
    okText = 'OK',
    cancelText = 'Cancel',
    centered = true,
    ...rest
}) => {
    return (
        <Modal
            title={title}
            open={open}
            onCancel={onCancel}
            onOk={onOk}
            okText={okText}
            cancelText={cancelText}
            centered={centered}
            width={width}
            {...rest}
        >
            {children}
        </Modal>
    );
};

export default CustomModal;
